// TRANSACTION_TYPES
export const TRANSACTION_TYPE_CASH = 1;
export const TRANSACTION_TYPE_MADA = 2;
export const TRANSACTION_TYPE_STC = 3;
export const TRANSACTION_TYPE_CREDIT = 4;

export const transactionTypes = [
  { id: 1, text: "Cash" },
  { id: 2, text: "MADA" },
  { id: 3, text: "STC Pay" },
  { id: 4, text: "Credit Card" },
];

// export const TAX_PERCENTAGE = 0.15;

// SUBSCRIPTION_PLANS
export const SUBSCRIPTION_PLAN_DAILY = "daily";
export const SUBSCRIPTION_PLAN_MONTHLY_YEARLY = "monthly or annually";

// Plan Types
export const PLAN_TYPE_BASIC = 1;
export const PLAN_TYPE_PRO = 2;
export const PLAN_TYPE_DAILY = 3;

// Plan Period
// export const PERIOD_MONTHLY = 1;
export const PERIOD_YEARLY = 2;
export const PERIOD_DAILY = 3;

// Addons billing cycle
export const BILLING_CYCLE_MONTHLY = 1;
export const BILLING_CYCLE_YEARLY = 2;
export const BILLING_CYCLE_DAILY = 3;

// Addons billing cycle types
// export const billingCycleTypes = [
//   { id: 1, text: "Monthly" },
//   { id: 2, text: "Yearly" },
//   { id: 3, text: "Daily" },
// ];

// REFUND_TYPE
// export const REFUND_TYPE_FULL = 1;
// export const REFUND_TYPE_PARTIAL = 2;

// User Types
export const USER_TYPE_MANAGER = 1; // manager
export const USER_TYPE_BUSINESS_OWNER = 2; // store owner
export const USER_TYPE_EMPLOYEE = 3; // store employee
export const USER_TYPE_ADMIN_STAFF = 4; // staff
export const USER_TYPE_SUPER_ADMIN = 5; // super admin

// Company Status
export const COMPANY_STATUS_ACTIVE = 1;
export const COMPANY_STATUS_KYC = 2;
export const COMPANY_STATUS_REVIEW = 3;
export const COMPANY_STATUS_SUBSCRIPTION_ENDED = 4;
export const COMPANY_STATUS_SUBSCRIPTION_IN_REVIEW = 5;
export const COMPANY_STATUS_UNPAID_INVOICE = 6;
export const COMPANY_STATUS_RECHARGE_REQUEST = 7;
export const COMPANY_STATUS_BLOCKED = 99;

export const companyStatus = [
  { id: 1, text: "Active" },
  { id: 2, text: "Submitting KYC" },
  { id: 3, text: "In Review" },
  { id: 4, text: "Subscription Ended" },
  { id: 5, text: "Subscription In Review" },
  // { id: 6, text: "Unpaid Invoice" },
  { id: 7, text: "Recharge Request" },
  { id: 99, text: "Blocked / Inactive" },
];

export const platformType = [
  { value: "handheld", text: "Handheld" },
  { value: "iphone", text: "Iphone" },
  { value: "smart phone android", text: "Smart Phone (Android)" },
  { value: "tablet", text: "Tablet" },
  { value: "ipad", text: "Ipad" },
  { value: "pos system window", text: "POS system (window)" },
  { value: "pos system android", text: "POS system (Android)" },
  { value: "macbook", text: "Macbook" },
  { value: "pc", text: "PC" },
];

// Invoice Detail Type
export const INVOICE_DETAIL_TYPE_SUBSCRIPTION = 1;
export const INVOICE_DETAIL_TYPE_LICENSE = 2;
export const INVOICE_DETAIL_TYPE_DISCOUNT = 3;
export const INVOICE_DETAIL_TYPE_TAX = 4;
export const INVOICE_DETAIL_TYPE_TOPUP = 7;

// Invoice Status
export const INVOICE_STATUS_UNPAID = 6;
export const INVOICE_STATUS_CANCELLED = 1;
export const INVOICE_STATUS_PAID = 2;
export const INVOICE_STATUS_REFUNDED = 3;

// Activity Status
export const ACTIVITY_CREATED = 1;
export const ACTIVITY_DONE = 2;

export const SIDEBAR_MENU_KEY_HOME = "home";

// Reseller rank
export const RANK_BASIC = "Basic";
export const RANK_PRO = "Pro";

// Reseller status
export const RESELLER_STATUS_ACTIVE = 1;
export const RESELLER_STATUS_KYC = 2;
export const RESELLER_STATUS_REJECTED = 3;
export const RESELLER_STATUS_REVIEW = 4;
export const RESELLER_STATUS_INACTIVE = 99;

// Reseller status lists
export const resellerStatus = [
  { id: 1, text: "Active" },
  { id: 2, text: "KYC" },
  { id: 3, text: "Rejected" },
  { id: 4, text: "In Review" },
  { id: 99, text: "Blocked / Inactive" },
];

// Balance Deduction Types
export const BALANCE_DEDUCTION_TYPE_SUBSCRIPTION = 1;
export const BALANCE_DEDUCTION_TYPE_QRORDER = 2;
export const BALANCE_DEDUCTION_TYPE_TABLEMANAGEMENT = 3;
export const BALANCE_DEDUCTION_TYPE_ORDERMANAGEMENT = 4;
export const BALANCE_DEDUCTION_TYPE_WAITERMANAGEMENT = 5;
export const BALANCE_DEDUCTION_TYPE_JOBMANAGEMENT = 6;
export const BALANCE_DEDUCTION_TYPE_STOCKMANAGEMENT = 7;
export const BALANCE_DEDUCTION_TYPE_SUREPAY = 8;
export const BALANCE_DEDUCTION_TYPE_CUSTOMERSMANAGEMENT = 9;
export const BALANCE_DEDUCTION_TYPE_SALESINVOICE = 10;
export const BALANCE_DEDUCTION_TYPE_TICKETING = 11;

export const deduction_types = [
  { id: 1, text: "Subscription" },
  { id: 2, text: "QR Order" },
  { id: 3, text: "Table Management" },
  { id: 4, text: "Order Management" },
  { id: 5, text: "Waiter Management" },
  { id: 6, text: "Job Management" },
  { id: 7, text: "Stock Management" },
  { id: 8, text: "Surepay" },
  { id: 9, text: "Customers Management" },
  { id: 10, text: "Sales Invoice" },
  { id: 11, text: "Ticketing" },
];
